import { format, utcToZonedTime } from 'date-fns-tz';

const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const timeformat = (t: string) => `${format(utcToZonedTime(t, timezone), 'dd-MMM-yyyy HH:mm:ss')} ${timezone}`;

export default timeformat;
